module.exports = __webpack_public_path__ + "media/images/lb/625-e40c11225aded177fa484bd9ff3eda3b.svg";